import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

export default new Router({
	base: process.env.BASE_URL,
	routes: [{
			path: '/',
			name: 'home',
			component: () => import('@/views/home.vue')
		},
		{
			path: '/movie',
			name: 'movie',
			component: () => import('@/views/movie.vue')
		},
		{
			path: '/cinema',
			name: 'cinema',
			component: () => import('@/views/cinema.vue')
		},
		{
			path: '/logIn',
			name: 'logIn',
			component: () => import('@/views/logIn.vue')
		},
		{
			path: '/register',
			name: 'register',
			component: () => import('@/views/register.vue')
		},
		{
			path: '/forgetPwd',
			name: 'forgetPwd',
			component: () => import('@/views/forgetPwd.vue')
		},
		{
			path: '/mvInfo',
			name: 'mvInfo',
			component: () => import('@/views/mvInfo.vue')
		},
		{
			path: '/cineDetail',
			name: 'cineDetail',
			component: () => import('@/views/cineDetail.vue')
		},
		{
			path: '/selSeat',
			name: 'selSeat',
			component: () => import('@/views/selSeat.vue')
		},
		{
			path: '/ticConfirm',
			name: 'ticConfirm',
			component: () => import('@/views/ticConfirm.vue')
		},
		{
			path: '/payOrder',
			name: 'payOrder',
			component: () => import('@/views/payOrder.vue')
		},
		{
			path: '/modify',
			name: 'modify',
			component: () => import('@/views/modify.vue')
		},
		{
			path: '/applyText',
			name: 'applyText',
			component: () => import('@/views/applyText.vue')
		},
		{
			path: '/idList',
			name: 'idList',
			component: () => import('@/views/idCards/idList.vue')
		},
	]
})
